import React, { Component } from "react";
import {
  Nav,
  NavbarBrand,
  NavItem,
  NavLink,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Navbar,
} from "reactstrap";
import { Link } from "react-router-dom";

export class CourseAdminNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
    };
  }
  headingTitle = () => {
    switch (this.props.location) {
      case "courses":
        return "Kurser";
      case "modules":
        return "Moduler";
      case "licenses":
        return "Licenser";
      case undefined:
        if (this.props.table === "studGrade") {
          return "Kursbetyg - Studentkommentarer";
        } else if (this.props.table === "moduleGrade") {
          return "Kursbetyg - Modulbetyg";
        }
        break;
      default:
        return "";
    }
  };
  render() {
    var toggleNav = () =>
      this.setState({ dropdownOpen: !this.state.dropdownOpen });

    return (
      <Navbar
        container={false}
        color="primary"
        dark
        expand="md"
        className="px-3"
      >
        <NavbarBrand>{this.headingTitle()}</NavbarBrand>
        <Nav className="ms-auto" navbar>
          <NavItem>
            <NavLink
              href="#"
              onClick={() => this.props.history.push("/superuser/courses")}
              title="Alla kurser"
              disabled={this.props.location === "courses"}
              active={this.props.location === "courses"}
            >
              Kurser
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              href="#"
              onClick={() =>
                this.props.history.push("/superuser/courses/modules")
              }
              disabled={this.props.location === "modules"}
              active={this.props.location === "modules"}
              title="Alla moduler"
            >
              Moduler
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              href="#"
              onClick={() =>
                this.props.history.push("/superuser/courses/licenses")
              }
              disabled={this.props.location === "licenses"}
              active={this.props.location === "licenses"}
              title="Licenser"
            >
              Licenser
            </NavLink>
          </NavItem>
          <Dropdown isOpen={this.state.dropdownOpen} toggle={toggleNav}>
            <DropdownToggle nav caret id="courseAdmin--Dropdown-toggler">
              Kursbetyg
            </DropdownToggle>
            <DropdownMenu className="mt-2" id="courseAdmin--Dropdown-menu">
              <DropdownItem
                tag="span"
                disabled={this.props.table === "studGrade"}
                active={this.props.table === "studGrade"}
                className="courseAdmin--Dropdown-item"
              >
                <Link
                  to={{
                    pathname: "/superuser/courses/ratings",
                    state: { table: "studGrade" },
                  }}
                  replace
                  className="courseAdminNav--Dropdown-link"
                >
                  Studentkommentarer
                </Link>
              </DropdownItem>
              <DropdownItem
                tag="span"
                disabled={this.props.table === "moduleGrade"}
                active={this.props.table === "moduleGrade"}
                className="courseAdmin--Dropdown-item"
              >
                <Link
                  to={{
                    pathname: "/superuser/courses/ratings",
                    state: { table: "moduleGrade" },
                  }}
                  replace
                  className="courseAdminNav--Dropdown-link"
                >
                  Modulbetyg
                </Link>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </Nav>
      </Navbar>
    );
  }
}
export default CourseAdminNav;
